module.exports = __webpack_public_path__ + "static/media/CanteenMember.b9bd5181.png";